module.exports = __webpack_public_path__ + "static/media/camera.aef449d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/tracking-map/camera.svg
// module id = 438
// module chunks = 0